// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryItem_container__2mimV","active":"CategoryItem_active__CizZj"};